import { createContext } from '@shared/utils/createContext';
import type { GuestRegistryState } from '../../GuestRegistry.controller';
import type { CheckoutServiceFacade } from './machines';
import type { ToastVariableProps } from '../../routes/GuestRegistry/GuestRegistry.controller';

type OpenCheckoutDialogArgs = Readonly<{
  registryItemId: string;
  currentOrderId?: string;
  isAffiliate?: boolean;
  isGiftWrapPurchased?: boolean;
  isGroupGiftingEnabled?: boolean;
  donationAmount?: number;
}>;

type CheckoutDialogContextValue = Readonly<{
  isOpen: boolean;
  registryItemId: Maybe<string>;
  currentOrderId: Maybe<string>;
  isAffiliate: boolean;
  isGroupGifting: boolean;
  registryState?: GuestRegistryState;
  profile: Maybe<{ id: string; email?: Maybe<string> }>;
  mySessionEmail: Maybe<string>;
  openCheckoutDialog: (args: OpenCheckoutDialogArgs) => void;
  disableCloseOnOutsideClick: boolean;
  setCurrentStep: (step: CheckoutServiceFacade['route']) => void;
  openToast?: (toast: ToastVariableProps) => void;
}>;

const [CheckoutDialogContextProvider, useCheckoutDialogContext] = createContext<CheckoutDialogContextValue>({ name: 'CheckoutDialog' });

export { CheckoutDialogContextProvider, useCheckoutDialogContext };
export type { CheckoutDialogContextValue, OpenCheckoutDialogArgs };
